<template>
  <div class="albums-page">
    <header class="albums-page__header">
      <div class="albums-page__header-inner">
        <router-link class="albums-page__back" to="/">← Startseite</router-link>
        <p class="albums-page__kicker"><span></span> Alle Nächte</p>
        <h1>Foto<em>alben.</em></h1>
        <p class="albums-page__lead">
          Die besten Momente der letzten Abende — stöbern, teilen und kommentieren.
        </p>
      </div>
    </header>
    <div v-if="loading" class="albums-grid albums-grid--loading md-mx3 mx2" aria-label="Alben werden geladen">
      <div class="album-loading-card" v-for="index in 8" :key="'skeleton-' + index">
        <div class="album-loading-card__image"></div>
        <div class="album-loading-card__copy">
          <span></span>
          <strong></strong>
          <strong></strong>
        </div>
      </div>
    </div>
    <div v-else-if="galleries.length" class="albums-grid md-mx3 mx2">
      <gallery-card
        v-for="gallery in galleries"
        :key="gallery.id"
        :galleryid="gallery.id"
        :title="gallery.name"
        :thumbnail="gallery.thumbnaillink"
        :created_at="gallery.created_at"
      />
    </div>
    <div v-else class="albums-page__empty md-mx3 mx2">
      <strong>Keine Alben gefunden.</strong>
      <button type="button" @click="loadGalleriesList">Erneut versuchen</button>
    </div>
  </div>
</template>
<script>
import { EventBus } from '../event-bus.js';
import GalleryCard from './GalleryCard.vue';
import axios from 'axios';
import { apiUrl } from '../api';
export default {
  name: "GalleryOverview",
  data() {
    return {
      session: {},
      galleries: [],
      loading: true
    };
  },
  components: {
    'gallery-card': GalleryCard,
  },
  created() {
    EventBus.$on('loginSuccessful', (payload) => {
      this.session = payload.session;
      this.loginStatus = true;
    });
    EventBus.$on('loginSuccessfulSubComponents', (payload) => {
      this.session = payload.session;

      this.loadGalleriesList();
    });
  },
  mounted(){
    EventBus.$emit('loginCheck', {});
    this.loadGalleriesList()
  },
  methods:{
    loadGalleriesList(){
      let that = this;
        that.loading = true;
        let url =  apiUrl('/public-api/get/galleries/json');
        axios.post(url)
        .then(response => {
          const list = (response.data && response.data.data) ? response.data.data.slice() : [];
          that.galleries = list.reverse();
        })
        .catch(function (error) {
          console.log(error);
          that.galleries = [];
        })
        .then(function () {
          that.loading = false;
        });
      }
  }
}
</script>
<style scoped>
.albums-page {
  padding: 0 0 5rem;
  background: var(--paper);
  min-height: 60vh;
}

.albums-page__header {
  position: relative;
  min-height: 340px;
  margin-bottom: 34px;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  border-bottom: 1px solid var(--line);
  background:
    radial-gradient(circle at 74% 20%, rgba(204,44,206,.2), transparent 32%),
    linear-gradient(135deg, #08080a 0%, #151017 60%, #08080a 100%);
}
.albums-page__header::after {
  content: 'ALBEN';
  position: absolute;
  right: -18px;
  bottom: -54px;
  color: rgba(255,255,255,.025);
  font-family: 'Archivo', sans-serif;
  font-size: clamp(120px, 22vw, 300px);
  font-weight: 800;
  line-height: .8;
}
.albums-page__header-inner {
  position: relative;
  z-index: 1;
  width: min(100%, 1320px);
  margin: 0 auto;
  padding: 42px clamp(22px, 5vw, 72px);
}
.albums-page__back {
  position: absolute;
  top: 38px;
  color: rgba(255,255,255,.58);
  font-family: 'Archivo', sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: .1em;
  text-transform: uppercase;
}
.albums-page__back:hover {
  color: #dcff21;
}
.albums-page__kicker {
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: rgba(255,255,255,.68);
  font-family: 'Archivo', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .18em;
  text-transform: uppercase;
}
.albums-page__kicker span {
  width: 22px;
  height: 3px;
  background: #cc2cce;
}
.albums-page__header h1 {
  color: #fff;
  font-family: 'Archivo', sans-serif;
  font-size: clamp(48px, 8vw, 104px);
  font-weight: 700;
  line-height: .84;
  text-transform: uppercase;
}
.albums-page__header h1 em {
  color: #cc2cce;
  font-style: normal;
  text-transform: none;
}

.albums-page__lead {
  max-width: 39rem;
  margin-top: 22px;
  color: var(--text-muted);
  font-family: 'Manrope', sans-serif;
  font-size: clamp(16px, 1.6vw, 19px);
  line-height: 1.6;
}

.albums-grid {
  width: min(calc(100% - 44px), 1320px);
  margin-right: auto !important;
  margin-left: auto !important;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  gap: clamp(14px, 2vw, 24px);
}

.albums-page__empty {
  min-height: 240px;
  color: var(--text-muted);
  padding: 2rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 18px;
}
.albums-page__empty button {
  padding: 12px 18px;
  color: #fff;
  border: 1px solid var(--line);
  font-family: 'Archivo', sans-serif;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}
.album-loading-card {
  aspect-ratio: 4 / 3;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255,255,255,.08);
  background: #121013;
}
.album-loading-card__image {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(110deg, transparent 18%, rgba(255,255,255,.055) 35%, transparent 52%) -200% 0 / 200% 100%,
    linear-gradient(180deg, #18141c, #0d0b0f);
  animation: albumCardShimmer 1.35s ease-in-out infinite;
}
.album-loading-card__copy {
  position: absolute;
  right: 18px;
  bottom: 18px;
  left: 18px;
}
.album-loading-card__copy span,
.album-loading-card__copy strong {
  display: block;
  border-radius: 2px;
  background: rgba(255,255,255,.12);
}
.album-loading-card__copy span {
  width: 32%;
  height: 7px;
  margin-bottom: 11px;
}
.album-loading-card__copy strong {
  width: 82%;
  height: 13px;
  margin-top: 7px;
}
.album-loading-card__copy strong:last-child {
  width: 58%;
}
@keyframes albumCardShimmer {
  to { background-position: 200% 0, 0 0; }
}

@media (max-width: 640px) {
  .albums-page__header {
    min-height: 300px;
  }
}
</style>
